import {StaticAuthProvider} from "@twurple/auth";
import {ApiClient} from "@twurple/api";

export default{
    name: "TwitchApiService",
    clientId: process.env.VUE_APP_TWITCH_API_CLIENT_ID,
    accessToken: process.env.VUE_APP_TWITCH_ACCESS_TOKEN,
    apiClient: null,
    connect(){
        const authProvider = new StaticAuthProvider(this.clientId, this.accessToken);
        this.apiClient = new ApiClient({ authProvider });
    },
    async isOnline(userName) {
        let stream = await this.apiClient.streams.getStreamByUserName(userName);
        return stream !== null
    }
}